'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _reactI18next = require('react-i18next');
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _numbers = require('../../helpers/numbers');
var _registration = require('../../helpers/registration');
var _misc = require('../../helpers/misc');
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _Table = require('@material-ui/core/Table');
var _Table2 = _interopRequireDefault(_Table);
var _TableBody = require('@material-ui/core/TableBody');
var _TableBody2 = _interopRequireDefault(_TableBody);
var _TableCell = require('@material-ui/core/TableCell');
var _TableCell2 = _interopRequireDefault(_TableCell);
var _TableHead = require('@material-ui/core/TableHead');
var _TableHead2 = _interopRequireDefault(_TableHead);
var _TableRow = require('@material-ui/core/TableRow');
var _TableRow2 = _interopRequireDefault(_TableRow);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultColor = '#545454';
var defaultAccentColor = '#794583';
var defaultBackgroundColor = '#F3F3F3';
var defaultShowPrice = true;
var styles = {
  loader: {
    display: 'block',
    margin: '2rem auto'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  gridContainer: {
    margin: function margin(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '2rem 0' : '2.5rem 0';
    }
  },
  eventInfoContainer: {
    background: function background(_ref2) {
      var backgroundColor = _ref2.otherProperties.backgroundColor;
      return backgroundColor || defaultBackgroundColor;
    },
    padding: function padding(_ref3) {
      var responsiveMode = _ref3.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '0.8rem 0' : '1rem 0';
    },
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  eventInfoText: {
    color: function color(_ref4) {
      var _color = _ref4.otherProperties.color;
      return _color || defaultColor;
    },
    padding: function padding(_ref5) {
      var responsiveMode = _ref5.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '0 1.5rem' : '0 2rem';
    },
    '& .complementary-text': {
      fontSize: '14px'
    }
  },
  tableContainer: {
    padding: '0'
  },
  table: {
    fontFamily: 'inherit',
    '& h2': {
      fontSize: function fontSize(_ref6) {
        var responsiveMode = _ref6.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '16px' : '18px';
      }
    }
  },
  tableHeader: {
    background: function background(_ref7) {
      var accentColor = _ref7.otherProperties.accentColor;
      return accentColor || defaultAccentColor;
    }
  },
  row: {
    color: function color(_ref8) {
      var _color2 = _ref8.otherProperties.color;
      return _color2 || defaultColor;
    },
    backgroundColor: function backgroundColor(_ref9) {
      var _backgroundColor = _ref9.otherProperties.backgroundColor;
      return _backgroundColor || defaultBackgroundColor;
    },
    '&:nth-of-type(2n)': {
      background: function background(_ref10) {
        var backgroundColor = _ref10.otherProperties.backgroundColor;
        return (0, _colorManipulator.darken)(backgroundColor || defaultBackgroundColor, 0.1);
      }
    },
    '& td:last-child': {
      paddingRight: function paddingRight(_ref11) {
        var responsiveMode = _ref11.responsiveMode;
        return responsiveMode === _ResponsiveModes.MOBILE ? '0' : '24px';
      }
    }
  },
  cell: {
    color: function color(_ref12) {
      var _color3 = _ref12.otherProperties.color;
      return _color3 || defaultColor;
    },
    fontSize: function fontSize(_ref13) {
      var responsiveMode = _ref13.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '14px' : '16px';
    },
    border: 'none',
    textAlign: 'center',
    height: '4rem',
    padding: function padding(_ref14) {
      var responsiveMode = _ref14.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '5px' : 'inherit';
    },
    '& .AvailabilityNumber': {},
    '& a': {
      textDecoration: 'none',
      color: function color(_ref15) {
        var accentColor = _ref15.otherProperties.accentColor;
        return accentColor || defaultAccentColor;
      },
      '&:visited': {
        color: function color(_ref16) {
          var accentColor = _ref16.otherProperties.accentColor;
          return accentColor || defaultAccentColor;
        }
      }
    }
  }
};
var RegistrationTypeTable = function (_Component) {
  _inherits(RegistrationTypeTable, _Component);
  function RegistrationTypeTable() {
    var _ref17;
    var _temp, _this, _ret;
    _classCallCheck(this, RegistrationTypeTable);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref17 = RegistrationTypeTable.__proto__ || Object.getPrototypeOf(RegistrationTypeTable)).call.apply(_ref17, [this].concat(args))), _this), _this.renderAvailability = function (value) {
      var t = _this.props.t;
      return _react2.default.createElement('p', {
        className: 'AvailabilityNumber'
      }, value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegistrationTypeTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        pagination = _props.pagination,
        t = _props.t,
        responsiveMode = _props.responsiveMode,
        otherProperties = _props.otherProperties;
      var showPrice = otherProperties.showPrice,
        showVAT = otherProperties.showVAT,
        showAvailability = otherProperties.showAvailability,
        displayedAttendeeTypes = otherProperties.displayedAttendeeTypes;
      var events = entities.events,
        attendee_types = entities.attendee_types;
      var isFetching = pagination.isFetching;
      var event = Object.keys(events).map(function (k) {
        return events[k];
      })[0];
      var eventUri = event.eventUri,
        eventId = event.id;
      var attendeeTypeIds = (0, _misc.filterAndSortAttendeeTypes)(attendee_types, displayedAttendeeTypes);
      var totalUsedSeats = (0, _registration.getTotalUsedSeats)(attendee_types);
      var table_size = null;
      var event_info_size = null;
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
          table_size = 7;
          event_info_size = 3;
          break;
        case _ResponsiveModes.TABLET:
          table_size = 8;
          event_info_size = 3;
          break;
        case _ResponsiveModes.MOBILE:
        default:
          table_size = 12;
          event_info_size = 12;
      }
      return _react2.default.createElement('div', {
        className: classes.container
      }, _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.gridContainer,
        spacing: 0,
        justify: 'center'
      }, _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: event_info_size,
        className: classes.eventInfoContainer
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.loader
      }) : _react2.default.createElement('div', {
        className: classes.eventInfoText
      }, _react2.default.createElement('h4', {
        className: 'hightlight-text'
      }, t('registration.register')), _react2.default.createElement('h3', {
        className: 'bold-text'
      }, _react2.default.createElement('strong', null, event.name)), _react2.default.createElement('p', {
        className: 'complementary-text'
      }))), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: table_size,
        className: classes.tableContainer
      }, _react2.default.createElement(_Table2.default, {
        className: classes.table
      }, _react2.default.createElement(_TableHead2.default, null, _react2.default.createElement(_TableRow2.default, {
        className: classes.tableHeader
      }, _react2.default.createElement(_TableCell2.default, null), (showPrice === undefined && defaultShowPrice || showPrice !== undefined && showPrice) && _react2.default.createElement(_TableCell2.default, null), !!showAvailability && _react2.default.createElement(_TableCell2.default, null))), _react2.default.createElement(_TableBody2.default, {
        className: classes.tableBody
      }, _react2.default.createElement(_TableRow2.default, {
        className: classes.row,
        key: 0
      }, _react2.default.createElement(_TableCell2.default, {
        className: classes.cell
      }, _react2.default.createElement('h2', null, _react2.default.createElement('strong', null, t('registration.type')))), (showPrice === undefined && defaultShowPrice || showPrice != undefined && showPrice) && _react2.default.createElement(_TableCell2.default, {
        className: classes.cell
      }, _react2.default.createElement('h2', null, _react2.default.createElement('strong', null, t('registration.price')))), !!showAvailability && _react2.default.createElement(_TableCell2.default, {
        className: classes.cell
      }, _react2.default.createElement('h2', null, _react2.default.createElement('strong', null, t('registration.available_seats'))))), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.loader
      }) : !!attendeeTypeIds.length ? attendeeTypeIds.map(function (attendee_type) {
        return _react2.default.createElement(_TableRow2.default, {
          className: classes.row,
          key: attendee_type
        }, _react2.default.createElement(_TableCell2.default, {
          className: classes.cell
        }, _react2.default.createElement('a', {
          href: (0, _registration.hasPlacesLeftForType)(attendee_types[attendee_type], event, totalUsedSeats) ? _urls2.default.getPublicRegisterUrl(eventUri, attendee_type, parseInt(eventId)) : undefined,
          target: '_blank'
        }, attendee_types[attendee_type].name)), (showPrice === undefined && defaultShowPrice || showPrice != undefined && showPrice) && _react2.default.createElement(_TableCell2.default, {
          className: classes.cell
        }, showVAT === undefined ? !!parseFloat(attendee_types[attendee_type].price) ? (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].price) + ' ' + event.currency : t('event.price.free') : showVAT ? !!parseFloat(attendee_types[attendee_type].price) ? (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].price) + ' ' + event.currency : t('event.price.free') : !!parseFloat(attendee_types[attendee_type].priceWithoutVat) ? (0, _numbers.addThousandsSeparator)(attendee_types[attendee_type].priceWithoutVat) + ' ' + event.currency : t('event.price.free')), !!showAvailability && _react2.default.createElement(_TableCell2.default, {
          className: classes.cell
        }, (0, _registration.hasPlacesLeftForType)(attendee_types[attendee_type], event, totalUsedSeats) ? !!attendee_types[attendee_type].capacity ? _this2.renderAvailability(parseFloat(attendee_types[attendee_type].availability)) : _react2.default.createElement('p', {
          className: 'AvailabilityNumber'
        }, t('registration.no_limit')) : _react2.default.createElement('p', {
          className: 'AvailabilityNumber'
        }, t('registration.soldOut'))));
      }) : _react2.default.createElement(_TableRow2.default, {
        className: classes.row,
        key: 1
      }, _react2.default.createElement(_TableCell2.default, {
        className: classes.cell
      }, _react2.default.createElement('h3', null, 'No attendee types :(')), (showPrice === undefined && defaultShowPrice || showPrice != undefined && showPrice) && _react2.default.createElement(_TableCell2.default, {
        className: classes.cell
      })))))));
    }
  }]);
  return RegistrationTypeTable;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(RegistrationTypeTable));